import type { DeviceStatus, DeviceType, EventSeverity } from '../types';

export const deviceTypeLabels: Record<DeviceType, string> = {
  camera: 'Камера',
  server: 'Сервер',
  computer: 'Компьютер',
  recorder: 'DVR / NVR',
};

export const statusLabels: Record<DeviceStatus, string> = {
  online: 'В сети',
  offline: 'Не в сети',
  warning: 'Предупреждение',
  critical: 'Критично',
  maintenance: 'Обслуживание',
  disabled: 'Отключено',
  updating: 'Обновление',
  unauthorized: 'Нет авторизации',
};

export const severityLabels: Record<EventSeverity, string> = {
  critical: 'Критическое',
  warning: 'Предупреждение',
  info: 'Информация',
  online: 'Восстановлено',
  offline: 'Не в сети',
};

export const formatCount = (count: number, one: string, few: string, many: string) => {
  const form = new Intl.PluralRules('ru-RU').select(count);
  return `${count} ${form === 'one' ? one : form === 'few' ? few : many}`;
};

export const formatDateTime = (value: string) =>
  new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value));

export const formatFullDateTime = (value: string) =>
  new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(new Date(value));

export const formatUptime = (hours?: number) => {
  if (hours == null) return 'Нет данных';
  if (hours < 24) return `${Math.round(hours)} ч`;
  const days = Math.floor(hours / 24);
  const remainingHours = Math.round(hours % 24);
  return `${days} д ${remainingHours} ч`;
};

export const formatRole = (role: 'Administrator' | 'Operator' | 'Viewer') => {
  if (role === 'Administrator') return 'Администратор';
  if (role === 'Operator') return 'Оператор';
  return 'Наблюдатель';
};
